import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";

import { ResponseModel } from '../models/response.model';
import { GeneralService } from './general.service';
import { PersistenceService } from 'angular-persistence';
import { environment } from '../../environments/environment';
import { Customer } from '../models';
import { CustomerInfoLog } from '../models/customerInfoLog.model';

@Injectable()
export class CustomerService extends GeneralService {
  constructor(protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
    super(httpClient, persistenceService, environment.apiCRMUrl, "customer");
  }

  getListNotAccept() {
    return super.getCustomApi("GetListNotAccept", null);
  }

  async getListNotAcceptAsync() {
    let res = await this.getListNotAccept().toPromise();
    return res;
  }

  async getCreatedByAsync(searchBy: any,isAccept: any, provinceId: any,customerTypeId:any, arrCols: string[] = [], pageSize: number = undefined, pageNumber: number = undefined):Promise<ResponseModel> {
    let params = new HttpParams();
    let cols = null;
    if (arrCols.length > 0) {
      cols = arrCols.join(',');
    }
    params = params.append("keySearch", searchBy);
    params = params.append("isAccept", isAccept);
    params = params.append("provinceId", provinceId);
    params = params.append('customerTypeId',customerTypeId);
    if (pageSize)
      params = params.append("pageSize", pageSize.toString());
    if (pageNumber)
      params = params.append("pageNumber", pageNumber.toString());
    if (cols)
      params = params.append("cols", cols);
    return super.getCustomApi("GetCreatedBy", params).toPromise<ResponseModel>();
  }
  async getListCustomer(searchBy: any,isAccept: any, provinceId: any,customerTypeId:any,  pageSize: number = undefined, pageNumber: number = undefined):Promise<ResponseModel> {
    let params = new HttpParams();
    params = params.append("keySearch", searchBy);
    params = params.append("isAccept", isAccept);
    params = params.append("provinceId", provinceId);
    params = params.append('customerTypeId',customerTypeId);
    if (pageSize)
      params = params.append("pageSize", pageSize.toString());
    if (pageNumber)
      params = params.append("pageNumber", pageNumber.toString());
    return await super.getCustomApi("GetListCustomerExport", params).toPromise();
  }
  getSearchByValue(value: string, id: any) {
    let params = new HttpParams;
    params = params.append("value", value);
    params = params.append("id", id);
    return super.getCustomUrlApiPaging(environment.apiCRMUrl, "searchByValue", [], params);
  }

  async getSearchByValueAsync(value: string, id: any): Promise<ResponseModel> {
    let res = await this.getSearchByValue(value, id).toPromise();
    return res;
  }

  getByListCode(listCode: string[]) {
    return super.postCustomUrlApi(environment.apiCRMUrl, "getByListCode", listCode);
  }

  async getByListCodeAsync(listCode: string[]): Promise<Customer[]> {
    const res = await this.getByListCode(listCode).toPromise();
    if (!res) {
      return;
    }
    const data = res.data as Customer[];
    return data;
  }

  async importListCustomer(data:any){
    let params = new FormData();
    params.append("file",data)
  return this.postCustomApi("ImportCustomer",params).toPromise()
  }
  async getByCustomerCodeAsync(code: string, id: any, pageSize: any, pageNum: any, cols: any): Promise<ResponseModel> {
    let params = new HttpParams();
    params = params.append("value", code);
    params = params.append("id", id);
    params = params.append("pageSize", pageSize);
    params = params.append("pageNum", pageNum);
    params = params.append("cols", cols);
    return super.getCustomApi("getByCustomerCode", params).toPromise();
  }

  async checkPhone(phone: string): Promise<any> {
    let params = new HttpParams();
    params = params.append("phone", phone);
    return super.getCustomApi("CheckPhone", params).toPromise();
  }

  async getListPhone(id: any): Promise<any> {
    let params = new HttpParams();
    params = params.append("customerId", id);
    return await super.getCustomApi("getListPhoneDebit", params).toPromise();
  }

  async getListRoutingDebit(customerId: any,typeId:any): Promise<any> {
    let params = new HttpParams();
    params = params.append("customerId", customerId);
    params = params.append("typeId", typeId);
    let res = await super.getCustomApi("getListRoutingDebit", params).toPromise();
    if(!res.isSuccess) return;
    return res.data;
    }
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/services/customer.service.ts